import { Button } from 'components/buttons/Button/Button';
import background from 'images/career-card.svg';

const TeamCareerCard = () => (
    <div className="team-career-card">
        <div className="team-career-card-inner">
            <img className="team-career-card__img" src={background} alt="" />
            <div className="team-career-card__content">
                <div>
                    <div className="h2">Career at UniferX</div>
                    <p className="body1 opacity-80">
                        We are always looking people to help us become better and invite you to grow with UniferX.
                    </p>
                </div>
                <Button type="button-arrow">View open jobs</Button>
            </div>
        </div>
    </div>
);

export default TeamCareerCard;
